module.exports = [{
      plugin: require('/Users/ben.ely/Sites/gatsby-theme-amplify-cognito/theme/gatsby-browser.js'),
      options: {"plugins":[],"region":"eu-west-1","userPoolId":"eu-west-2_GhDUSwQxW","userPoolWebClientId":"3vk8emt60ne73u165dbd5d75a8"},
    }]
